// import { Action } from 'redux';
// import { delay } from 'redux-saga';
import { NotificationManager } from 'react-notifications';
import { Action } from 'redux';
import {
  call,
  // cancel,
  // fork,
  put,
  select,
  takeLatest
} from 'redux-saga/effects';
import { RootState } from 'types/store';
import { getType } from 'typesafe-actions';
import { sendRegisterEmail } from 'utils/sendRegisterEmail';
import * as actions from './actions';

function* submitForm(
  action: Action<actions.ISubmitFormPayload> & {
    payload: actions.ISubmitFormPayload;
  }
) {
  const state: RootState = yield select();
  const registration = state.registration;
  yield put(actions.setSubmitting({ submitting: true }));
  try {
    yield call(sendRegisterEmail, {
      captain: {
        ...registration.captain
      },
      event: registration.event ? registration.event.name : '',
      players: registration.players,
      reserves: registration.reserves,
      team: registration.team,
      to: action.payload.to
    });
    NotificationManager.success(action.payload.successText);
    yield put(actions.resetForm());
  } catch (e) {
    NotificationManager.warning(action.payload.errorText);
    // set error
  }
  yield put(actions.setSubmitting({ submitting: false }));
}

export default function*() {
  yield takeLatest(getType(actions.submitForm), submitForm);
}



// WEBPACK FOOTER //
// ./src/store/modules/registration/saga.ts